import React, { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

export default function AdminEditorialBoardSubmissions() {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    fetchSubmissions();
  }, []);

  async function fetchSubmissions() {
    setLoading(true);
    const { data, error } = await supabase.from('editorial_board_submissions').select('*').order('created_at', { ascending: false });
    setSubmissions(data || []);
    setLoading(false);
  }

  async function handleDelete(id) {
    if (!window.confirm('Are you sure you want to delete this submission?')) return;
    await supabase.from('editorial_board_submissions').delete().eq('id', id);
    fetchSubmissions();
  }

  async function handleStatusChange(submission, newStatus) {
    // Update status in editorial_board_submissions
    await supabase.from('editorial_board_submissions').update({ status: newStatus }).eq('id', submission.id);
    // If accepted, update user role to reviewer
    if (newStatus === 'accepted' && submission.email) {
      await supabase.from('users').update({ role: 'reviewer' }).eq('email', submission.email);
    }
    fetchSubmissions();
  }

  return (
    <div className="container py-5" style={{maxWidth: 1100}}>
      <h2 className="fw-bold mb-4">Editorial Board Applications</h2>
      {loading ? (
        <div>Loading...</div>
      ) : submissions.length === 0 ? (
        <div className="alert alert-info">No submissions found.</div>
      ) : (
        <table className="table table-bordered table-hover align-middle bg-white">
          <thead className="table-light">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Email</th>
              <th>Institution</th>
              <th>Country</th>
              <th>Submitted</th>
              <th>Actions</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {submissions.map((s, i) => (
              <React.Fragment key={s.id}>
                <tr>
                  <td>{i + 1}</td>
                  <td>{s.name}</td>
                  <td>{s.email}</td>
                  <td>{s.institution}</td>
                  <td>{s.country}</td>
                  <td>{s.created_at ? new Date(s.created_at).toLocaleString() : ''}</td>
                  <td>
                    <button className="btn btn-sm btn-outline-primary" onClick={() => setExpanded(expanded === s.id ? null : s.id)}>
                      {expanded === s.id ? 'Hide' : 'View'}
                    </button>
                    <button className="btn btn-sm btn-outline-danger ms-2" onClick={() => handleDelete(s.id)}>
                      Delete
                    </button>
                  </td>
                  <td>
                    <select className="form-select form-select-sm" value={s.status || ''} onChange={e => handleStatusChange(s, e.target.value)}>
                      <option value="">Select</option>
                      <option value="pending">Pending</option>
                      <option value="accepted">Accept</option>
                      <option value="rejected">Reject</option>
                    </select>
                  </td>
                </tr>
                {expanded === s.id && (
                  <tr>
                    <td colSpan={7}>
                      <div className="p-3 bg-light rounded">
                        <div className="row g-3">
                          <div className="col-md-4"><b>Department:</b> {s.department}</div>
                          <div className="col-md-4"><b>Qualification:</b> {s.qualification}</div>
                          <div className="col-md-4"><b>Profile Link:</b> <a href={s.profile_link} target="_blank" rel="noopener noreferrer">{s.profile_link}</a></div>
                          <div className="col-md-4"><b>Awards:</b> {s.awards}</div>
                          <div className="col-md-4"><b>Timezone:</b> {s.timezone}</div>
                          <div className="col-md-4"><b>Availability:</b> {s.availability}</div>
                          <div className="col-md-4"><b>Languages:</b> {s.languages}</div>
                          <div className="col-md-4"><b>Topics:</b> {s.topics}</div>
                          <div className="col-md-4"><b>Reviewed Before:</b> {s.reviewed_before}</div>
                          <div className="col-md-4"><b>Reviewed Journals:</b> {s.reviewed_journals}</div>
                          <div className="col-md-4"><b>Experience:</b> {s.experience}</div>
                          <div className="col-md-4"><b>Statement:</b> {s.statement}</div>
                          <div className="col-md-4"><b>Agreement:</b> {s.agreement ? 'Yes' : 'No'}</div>
                          <div className="col-md-4"><b>Signature:</b> {s.signature}</div>
                          <div className="col-md-4"><b>ORCID:</b> {s.orcid}</div>
                          <div className="col-md-4"><b>CV:</b> {s.cv_url && <a href={s.cv_url} target="_blank" rel="noopener noreferrer">View CV</a>}</div>
                          <div className="col-md-4"><b>Profile Pic:</b> {s.profile_pic_url && <a href={s.profile_pic_url} target="_blank" rel="noopener noreferrer">View</a>}</div>
                        </div>
                        <div className="mt-3"><b>Publications:</b>
                          <ul>
                            {Array.isArray(s.publications ? JSON.parse(s.publications) : []) && JSON.parse(s.publications).map((pub, idx) => (
                              <li key={idx}>{pub.title} ({pub.journal}) {pub.link && <a href={pub.link} target="_blank" rel="noopener noreferrer">[Link]</a>}</li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
} 